import { render } from "./BannerPositionSet.vue?vue&type=template&id=50edaa2e&scoped=true&ts=true"
import script from "./BannerPositionSet.vue?vue&type=script&lang=ts"
export * from "./BannerPositionSet.vue?vue&type=script&lang=ts"

import "./BannerPositionSet.vue?vue&type=style&index=0&id=50edaa2e&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50edaa2e"]])

export default __exports__